import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import type { ApiPage } from 'src/core/models/api/ApiPage';
import type { RootNavigation } from 'src/presentation/navigation/types/NavigationTypes';

type RootNav = NativeStackNavigationProp<RootNavigation>;

/**
 * The CMS backend sends route names as strings (`page.type`) that map to entries in `RootNavigation`.
 */

export function navigatePage(navigation: RootNav, type: string, data: ApiPage, extra?: Record<string, unknown>): void {
	(navigation.navigate as (name: string, params: unknown) => void)(type, { data, ...extra });
}

export function pushPage(navigation: RootNav, type: string, data: ApiPage, extra?: Record<string, unknown>): void {
	(navigation.push as (name: string, params: unknown) => void)(type, { data, ...extra });
}

export function replacePage(navigation: RootNav, type: string, params?: Record<string, unknown>): void {
	(navigation.replace as (name: string, params?: unknown) => void)(type, params);
}
